import Constant from '@/const';
import axios from 'axios';

const getDinkesDataExport = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/report/visitors/dinkes/export'),
      {
        params,
      },
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getDinkesDataExport;
